var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#3C77EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 18C27 22.4923 23.7087 26.2157 19.4062 26.8907V20.6016H21.5033L21.9023 18H19.4062V16.3118C19.4062 15.5999 19.755 14.9062 20.873 14.9062H22.0078V12.6914C22.0078 12.6914 20.9777 12.5156 19.993 12.5156C17.9374 12.5156 16.5938 13.7616 16.5938 16.0172V18H14.3086V20.6016H16.5938V26.8907C12.2913 26.2157 9 22.4923 9 18C9 13.0296 13.0296 9 18 9C22.9704 9 27 13.0296 27 18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5033 20.6016L21.9023 18H19.4062V16.3118C19.4062 15.6 19.7549 14.9062 20.8729 14.9062H22.0078V12.6914C22.0078 12.6914 20.9779 12.5156 19.9932 12.5156C17.9374 12.5156 16.5938 13.7616 16.5938 16.0172V18H14.3086V20.6016H16.5938V26.8906C17.052 26.9625 17.5216 27 18 27C18.4784 27 18.948 26.9625 19.4062 26.8906V20.6016H21.5033Z",
    fill: "#1877F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f6e8c6aad7d41be262b95d1e78be39f1.svg";
export { ForwardRef as ReactComponent };